var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearchPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M6.5 0a6.5 6.5 0 0 1 5.257 10.324L16 14.5 14.5 16l-4.176-4.243A6.5 6.5 0 1 1 6.5 0m0 2a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M7 4v2h2v1H7v2H6V7H4V6h2V4z"
})));
export default SvgSearchPlus;